<template>
  <v-container class="mt-4 mb-4">
    <v-row>
      <v-col cols="12">
        <v-card flat style="padding: 10px">
          <v-card-title>
            <h3 class="headline">Pipelines</h3>
          </v-card-title>
          <v-card-text>
            <v-data-iterator
              :items="items"
              :items-per-page.sync="itemsPerPage"
              :page.sync="page"
              :search="search"
              :sort-by="sortBy.toLowerCase()"
              :sort-desc="sortDesc"
              hide-default-footer
            >
              <template v-slot:header>
                <v-toolbar dense dark color="primary" class="mb-1">
                  <v-text-field
                    v-model="search"
                    dense
                    clearable
                    flat
                    solo-inverted
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                    style="margin-left: 10px"
                  ></v-text-field>
                  <template v-if="$vuetify.breakpoint.mdAndUp">
                    <v-spacer></v-spacer>
                    <v-select
                      v-model="sortBy"
                      dense
                      flat
                      solo-inverted
                      hide-details
                      :items="keys"
                      prepend-inner-icon="mdi-magnify"
                      label="Sort by"
                    ></v-select>
                    <v-spacer></v-spacer>
                    <v-btn-toggle
                      v-model="sortDesc"
                      mandatory
                      style="margin-right: 10px"
                    >
                      <v-btn large depressed color="primary" :value="false">
                        <v-icon>mdi-arrow-up</v-icon>
                      </v-btn>
                      <v-btn large depressed color="primary" :value="true">
                        <v-icon>mdi-arrow-down</v-icon>
                      </v-btn>
                    </v-btn-toggle>
                  </template>
                </v-toolbar>
              </template>

              <template v-slot:default="props">
                <v-row>
                  <v-col v-for="item in props.items" :key="item.name" cols="12">
                    <v-card>
                      <div class="d-flex flex-no-wrap justify-space-between">
                        <v-col cols="4">
                          <v-card-title class="subheading font-weight-bold">
                            {{ item.name }}
                          </v-card-title>

                          <!-- <v-card-subtitle v-text="item.artist"></v-card-subtitle> -->
                          <v-card-subtitle>{{ item.author }}</v-card-subtitle>

                          <v-card-text class="text-left">
                            Version: {{ item.version }}
                          </v-card-text>

                          <v-btn
                            class="ml-2 mt-5"
                            outlined
                            small
                            @click="
                              $router.push(
                                {
                                  name: 'PipelineRun',
                                  params: { id: item.id },
                                },
                                () => {}
                              )
                            "
                          >
                            <v-icon left>mdi-play</v-icon>
                            Run
                          </v-btn>
                        </v-col>
                        <v-divider vertical></v-divider>
                        <v-col cols="6">
                          <v-card-text
                            v-text="item.description"
                            class="text-left"
                          >
                          </v-card-text>
                        </v-col>
                        <v-col cols="2">
                          <v-avatar tile color="primary" class="ma-3" size="96">
                            <span class="white--text">{{ item.name }}</span>
                          </v-avatar>
                        </v-col>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </template>

              <template v-slot:footer>
                <v-row class="mt-2" align="center" justify="center">
                  <span class="grey--text">Items per page</span>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        dark
                        text
                        color="primary"
                        class="ml-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ itemsPerPage }}
                        <v-icon>mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(number, index) in itemsPerPageArray"
                        :key="index"
                        @click="updateItemsPerPage(number)"
                      >
                        <v-list-item-title>{{ number }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>

                  <v-spacer></v-spacer>

                  <span class="mr-4 grey--text">
                    Page {{ page }} of {{ numberOfPages }}
                  </span>
                  <v-btn
                    fab
                    dark
                    small
                    color="blue darken-3"
                    class="mr-1"
                    @click="formerPage"
                  >
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                  <v-btn
                    fab
                    dark
                    small
                    color="blue darken-3"
                    class="ml-1"
                    @click="nextPage"
                  >
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </v-row>
              </template>
            </v-data-iterator>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
  
  <script>
import { API, OWL_PIPELINE_DEFINITION } from "@/axios-config";

export default {
  name: "PipelinesView",
  data() {
    return {
      itemsPerPageArray: [4, 8, 12],
      search: "",
      filter: {},
      sortDesc: false,
      page: 1,
      itemsPerPage: 4,
      sortBy: "name",
      keys: ["Name", "Version"],
      items: [],
    };
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.items.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter((key) => key !== "Name");
    },
  },
  methods: {
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
  },
  mounted: function () {
    this.$nextTick(async function () {
      // Code that will run only after the
      // entire view has been rendered
      // we can run async functions here

      try {
        const { data } = await API.get(OWL_PIPELINE_DEFINITION);
        this.items = data;
      } catch (error) {
        console.log(error);
      }
    });
  },
};
</script>